import { callPost } from '../../services/axios'
import { getISODate } from '../../services/helper'

import {
  GET_KEYWORD_SUCCEED,
  GET_KEYWORD_FAIL,
  GET_KEYWORD_START,
  GET_EXPORT_KEYWORD_SUCCEED,
  GET_EXPORT_KEYWORD_FAIL,
  GET_EXPORT_KEYWORD_START
} from '../actionTypes/keyword'

export const getKeywords = (
  accessToken,
  startDate,
  endDate,
  pageNum,
  pageRows,
  keywordSearchValue,
  filterValues,
  signal
) => (dispatch, getState) => {
  try {
    dispatch({
      type: GET_KEYWORD_START,
    })

    const {
      header: { currentUserId },
    } = getState()

    return callPost('/keywords/getKeywordsData', {
      userId: currentUserId,
      startDate: startDate ? getISODate(startDate) : null,
      endDate: endDate ? getISODate(endDate) : null,
      page: pageNum,
      pageSize: pageRows,
      search: keywordSearchValue,
      filters: filterValues.campaignDetailBidKeyword ?? []
    }, accessToken, signal)
      .then((response) => {
        dispatch({
          type: GET_KEYWORD_SUCCEED,
          data: response.data,
        })
      })
      .catch((error) => {
        if (error.code === 'ERR_CANCELED') {
          dispatch({
            type: GET_KEYWORD_FAIL,
            error: 'Request cancelled',
          })
        } else {
          dispatch({
            type: GET_KEYWORD_FAIL,
            error: error.response.data,
          })
        }
      })
  } catch (error) {
    if (error.name === 'AbortError') {
      return // Don't dispatch error for aborted requests
    }
    dispatch({ type: GET_KEYWORD_FAIL, payload: error.message })
  }
}

export const getExportKeywords = (
  accessToken,
  startDate,
  endDate,
  filterValues,
  signal
) => (dispatch, getState) => {
  try {
    dispatch({
      type: GET_EXPORT_KEYWORD_START,
    })

    const {
      header: { currentUserId },
    } = getState()

    return callPost('/keywords/getExportKeywordsData', {
      userId: currentUserId,
      startDate: startDate ? getISODate(startDate) : null,
      endDate: endDate ? getISODate(endDate) : null,
      filters: filterValues.campaignDetailBidKeyword ?? []
    }, accessToken, signal)
      .then((response) => {
        dispatch({
          type: GET_EXPORT_KEYWORD_SUCCEED,
          data: response.data,
        })
        return response.data
      })
      .catch((error) => {
        if (error.code === 'ERR_CANCELED') {
          dispatch({
            type: GET_KEYWORD_FAIL,
            error: 'Request cancelled',
          })
        } else {
          dispatch({
            type: GET_KEYWORD_FAIL,
            error: error.response.data,
          })
        }
      })
  } catch (error) {
    if (error.name === 'AbortError') {
      return // Don't dispatch error for aborted requests
    }
    dispatch({ type: GET_EXPORT_KEYWORD_FAIL, payload: error.message })
  }
}

